import { Row, Col, Form } from "react-bootstrap";
import { SimpleFormCheck } from "../form/SimpleFormCheck";
import { SimpleFormControl } from "../form/SimpleFormControl";
import { SimpleFormSelect, SimpleFormSelectOption } from "../form/SimpleFormSelect";
import { useField } from "formik";
import { useIntl } from "react-intl";
import { useEffect } from "react";

export interface IAskForPlanning {
    projectManagers: { options: SimpleFormSelectOption[]; loading: boolean };
    planningMonthsOptions: SimpleFormSelectOption[];
}
const AskForPlanningForm = (props: IAskForPlanning) => {
    const { projectManagers, planningMonthsOptions } = props;

    const { formatMessage } = useIntl();

    const [orderFilling] = useField("orderType.filling");
    const [orderRanking] = useField("orderType.ranking");
    const [orderNetlinking] = useField("orderType.netlinking");
    const [orderBoost] = useField("orderType.boost");
    const [orderLead] = useField("orderType.lead");
    const [orderDiscover] = useField("orderType.discover");
    const [, , orderSilo] = useField("orderType.silo");
    const [fillingValueProp, , fillingValue] = useField("fillingValue");
    const [boostValueProp, , boostValue] = useField("boostValue");
    const [leadValueProp, , leadValue] = useField("leadValue");
    const [discoverValueProp, , discoverValue] = useField("discoverValue");
    const [rankingValueProp, , rankingValue] = useField("rankingValue");
    const [netlinkingValueProp, , netlinkingValue] = useField("netlinkingValue");

    useEffect(() => {
        if (!orderFilling.value) {
            fillingValue.setValue(null);
        } else if (!fillingValueProp.value) {
            fillingValue.setValue(16);
        }

        if (!orderRanking.value) {
            rankingValue.setValue(null);
        } else if (!rankingValueProp.value) {
            rankingValue.setValue(8);
        }

        if (!orderBoost.value) {
            boostValue.setValue(null);
        } else if (!boostValueProp.value) {
            boostValue.setValue(16);
        }

        if (!orderLead.value) {
            leadValue.setValue(null);
        } else if (!leadValueProp.value) {
            leadValue.setValue(16);
        }

        if (!orderDiscover.value) {
            discoverValue.setValue(null);
        } else if (!discoverValueProp.value) {
            discoverValue.setValue(16);
        }

        if (!orderNetlinking.value) {
            netlinkingValue.setValue(null);
            orderSilo.setValue(null);
        } else if (!netlinkingValueProp.value) {
            netlinkingValue.setValue(4);
            orderSilo.setValue(true);
        }
    }, [
        orderFilling.value,
        orderRanking.value,
        orderNetlinking.value,
        orderBoost.value,
        orderLead.value,
        orderDiscover.value,
    ]);

    return (
        <Row>
            <Col>
                <SimpleFormSelect
                    isLoading={projectManagers.loading}
                    name="projectManagerId"
                    label={formatMessage({ id: "common.field.projectManager" })}
                    values={projectManagers.options}
                />
                <SimpleFormSelect
                    name="months"
                    label={formatMessage({ id: "common.field.howLong" })}
                    values={planningMonthsOptions}
                />
            </Col>
            <Col>
                <p>{formatMessage({ id: "common.field.whatPlan" })}</p>
                <Col>
                    <Row>
                        <Col>
                            <SimpleFormCheck
                                label={formatMessage({ id: "common.field.filling" })}
                                name="orderType.filling"
                                cssClass={["stepperInput"]}
                            />
                        </Col>
                        <Col style={{ height: "57px" }}>
                            {orderFilling?.value ? (
                                <div className="d-flex gap-2">
                                    <Form.Label>
                                        {formatMessage({ id: "common.field.perMonth" })}
                                    </Form.Label>
                                    <SimpleFormControl type="number" min={1} name="fillingValue" />
                                </div>
                            ) : (
                                <div />
                            )}
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col>
                            <SimpleFormCheck
                                label={formatMessage({ id: "common.field.ranking" })}
                                name="orderType.ranking"
                                cssClass={["stepperInput"]}
                            />
                        </Col>
                        <Col style={{ height: "57px" }}>
                            {orderRanking?.value ? (
                                <div className="d-flex gap-2">
                                    <Form.Label>
                                        {formatMessage({ id: "common.field.perMonth" })}
                                    </Form.Label>
                                    <SimpleFormControl type="number" min={1} name="rankingValue" />
                                </div>
                            ) : (
                                <div />
                            )}
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col>
                            <SimpleFormCheck
                                label={formatMessage({ id: "common.field.boost" })}
                                name="orderType.boost"
                                cssClass={["stepperInput"]}
                            />
                        </Col>
                        <Col style={{ height: "57px" }}>
                            {orderBoost?.value ? (
                                <div className="d-flex gap-2">
                                    <Form.Label>
                                        {formatMessage({ id: "common.field.perMonth" })}
                                    </Form.Label>
                                    <SimpleFormControl type="number" min={1} name="boostValue" />
                                </div>
                            ) : (
                                <div />
                            )}
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col>
                            <SimpleFormCheck
                                label={formatMessage({ id: "common.field.lead" })}
                                name="orderType.lead"
                                cssClass={["stepperInput"]}
                            />
                        </Col>
                        <Col style={{ height: "57px" }}>
                            {orderLead?.value ? (
                                <div className="d-flex gap-2">
                                    <Form.Label>
                                        {formatMessage({ id: "common.field.perMonth" })}
                                    </Form.Label>
                                    <SimpleFormControl type="number" min={1} name="leadValue" />
                                </div>
                            ) : (
                                <div />
                            )}
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col>
                            <SimpleFormCheck
                                label={formatMessage({ id: "common.field.discover" })}
                                name="orderType.discover"
                                cssClass={["stepperInput"]}
                            />
                        </Col>
                        <Col style={{ height: "57px" }}>
                            {orderDiscover?.value ? (
                                <div className="d-flex gap-2">
                                    <Form.Label>
                                        {formatMessage({ id: "common.field.perMonth" })}
                                    </Form.Label>
                                    <SimpleFormControl type="number" min={1} name="discoverValue" />
                                </div>
                            ) : (
                                <div />
                            )}
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col>
                            <SimpleFormCheck
                                label={formatMessage({ id: "common.field.netlinking" })}
                                name="orderType.netlinking"
                                cssClass={["stepperInput"]}
                            />
                        </Col>
                        {orderNetlinking?.value ? (
                            <>
                                <Col style={{ height: "57px" }}>
                                    <div className="d-flex gap-2">
                                        <Form.Label>
                                            {formatMessage({ id: "common.field.perMonth" })}
                                        </Form.Label>
                                        <SimpleFormControl
                                            type="number"
                                            min={1}
                                            name="netlinkingValue"
                                        />
                                    </div>
                                </Col>
                                <Row>
                                    <Col style={{ height: "57px" }}>
                                        <div className="d-flex gap-2">
                                            <SimpleFormCheck
                                                label={formatMessage({
                                                    id: "common.field.silo",
                                                })}
                                                name="orderType.silo"
                                                cssClass={["stepperInput"]}
                                            />
                                        </div>
                                    </Col>
                                    <Col style={{ height: "57px" }}>
                                        <div className="d-flex gap-2">
                                            <Form.Label>
                                                {formatMessage({ id: "common.field.price" })}
                                            </Form.Label>
                                            <SimpleFormControl type="number" min={1} name="price" />
                                        </div>
                                    </Col>
                                </Row>
                            </>
                        ) : (
                            <div />
                        )}
                    </Row>
                </Col>
            </Col>
        </Row>
    );
};

export default AskForPlanningForm;
